export default __webpack_public_path__ + "static/media/landing-family.2cdac581b46ca24d.jpg";